module.exports = __webpack_public_path__ + "img/info.9984f092.svg";